import { configureStore } from '@reduxjs/toolkit';
import AccrualsReportR from "./reducers/reports/accruals_report";
import APARComparisonReducer from "./reducers/Admin/APARComparison";
import BankReducer from "./reducers/file-conversion/bank";
import BillingServicesR from "./reducers/Admin/billing-services";
import CertifiedPayrollSettings from "./reducers/Admin/certifiedPayrollSettings";
import CompaniesReducer from "./reducers/Admin/clients";
import CompanyEins from "./reducers/companyEins";
import ConversionToolReducer from "./reducers/file-conversion/soh-tool-old";
import CostCenterJobs from "./reducers/costCenterJobs";
import CostCenterReducer from "./reducers/Admin/cost-center";
import CsrAssignmentsR from "./reducers/Admin/csrAssignments";
import DeductionCodes from "./reducers/deductionCodes";
import DeductionSchedules from './reducers/Admin/deductionSchedules';
import DirectDepositReducer from "./reducers/file-conversion/direct-deposit";
import EarningCodeReducer from "./reducers/Admin/earning-code";
import EditClientData from "./reducers/Admin/editReportData";
import EINReducer from "./reducers/Admin/defaultEin";
import InventoryItems from "./reducers/Admin/inventoryItems";
import LatePayrollReducer from "./reducers/reports/latePayrollDetail";
import NewHireReducer from "./reducers/file-conversion/new-hire";
import NJCertifiedSettings from './reducers/Admin/njCertifiedSettings';
import NoPayrollActiveReducer from "./reducers/reports/no-payroll-active";
import OrderIdR from "./reducers/Admin/orderId";
import PatientReducer from "./reducers/reports/patient-hours";
import PayPeriodProfiles from "./reducers/payPeriodProfiles";
import PayrollComparisonsReducer from "./reducers/reports/payroll-comparisons";
import payrollR from "./reducers/payrollR";
import PermissionReducer from "./reducers/Admin/permission";
import PPDReducer from "./reducers/PPD";
import PurchaseOrder from "./reducers/Admin/purchaseOrder";
import ReportIdReducer from "./reducers/Admin/reportIdR";
import ReportSettingsReducer from "./reducers/Admin/report-settings";
import RoleListReducer from "./reducers/Admin/roleListR";
import RoleReducer from "./reducers/Admin/roleR";
import SaleOrders from "./reducers/Admin/saleOrders";
import savedEarningsCodes from "./reducers/Admin/savedEarningsCodesR";
import SchedulerReportsReducer from './reducers/reports/scheduler-reports';
import setError from "./reducers/errorReducer";
import SOHSettings from "./reducers/file-conversion/soh-settings";
import SOHTool from "./reducers/file-conversion/soh-tool";
import TaxCollectionReducer from "./reducers/file-conversion/tax-collection";
import TaxPaymentReducer from "./reducers/file-conversion/tax-payment";
import TeamSupportRegisterReducer from "./reducers/Admin/team-support-register";
import TurnoverReducer from "./reducers/reports/turnover";
import UserErrorReducer from "./reducers/userError";
import UserReducer from "./reducers/User";
import Users from "./reducers/Admin/users";
import WageLocationReducer from "./reducers/wage-location";
import WageParityReducer from "./reducers/reports/wage-parity";
import WageReducer from "./reducers/Admin/wage";
import WarrantyExpirationR from "./reducers/Admin/warrantyExpiration";
import WPSetupReducer from "./reducers/Admin/WPSetup";
//import api from './apiSlice';

const store = configureStore({
    reducer: {
        AccrualsReportReducer: AccrualsReportR,
        APARComparisonReducer,
        BankReducer,
        BillingServicesReducer: BillingServicesR,
        CSRAssignmentReducer: CsrAssignmentsR,
        CertifiedPayrollReducer: CertifiedPayrollSettings,
        ClientDataReducer: EditClientData,
        CompaniesReducer,
        CompanyEinsReducer: CompanyEins,
        ConversionToolReducer,
        CostCenterJobsReducer: CostCenterJobs,
        CostCenterReducer,
        DeductionCodesReducer: DeductionCodes,
        DeductionSchedulesReducer: DeductionSchedules,
        DirectDepositReducer,
        EINReducer,
        EarningCodeReducer,
        InventoryItemsReducer: InventoryItems,
        LatePayrollReducer,
        NJCertifiedSettingsReducer: NJCertifiedSettings,
        NewHireReducer,
        NoPayrollActiveReducer,
        OrderIdReducer: OrderIdR,
        PPDReducer,
        PatientReducer,
        PayPeriodProfilesReducer: PayPeriodProfiles,
        PayrollComparisonsReducer,
        PayrollReducer: payrollR,
        PermissionReducer,
        PurchaseOrderReducer: PurchaseOrder,
        ReportIdReducer,
        ReportSettingsReducer,
        RoleListReducer,
        RoleReducer,
        SchedulerReportsReducer,
        SOHSettingsReducer: SOHSettings,
        SOHToolReducer: SOHTool,
        SaleOrdersReducer: SaleOrders,
        SavedECReducer: savedEarningsCodes,
        SetErrorReducer: setError,
        TaxCollectionReducer,
        TaxPaymentReducer,
        TeamSupportRegisterReducer,
        TurnoverReducer,
        UserErrorReducer,
        UserReducer,
        UsersReducer: Users,
        WPSetupReducer,
        WageLocationReducer,
        WageParityReducer,
        WageReducer,
        WarrantyExpirationReducer: WarrantyExpirationR,
        //[api.reducerPath]: api.reducer,
    },
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({ immutableCheck: false, serializableCheck: false }),
});
export default store;
